<template>
  <div class="w-100">
    <template v-if="player">
    <div class="headline d-flex flex-row align-items-center justify-content-between w-100 border-bottom pb-3">
      <h2 class="card-title font-weight-bolder">{{ $t('title.login_history') }}</h2>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <div class="questions sygni-grid">
          <div class="">
            <div class="filters">

              <div class="row">
                <div class="col-4">
                  <filter-date-range-picker
                      :filter-query="filterQuery"
                      :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                      :auto="true"
                      :linked="false"
                      :time-picker="true"
                      filter-name="loginDate"
                      open-direction="left"
                      :label="$t('filters.label.last_login_date')">
                  </filter-date-range-picker>
                </div>
                <div class="col-4">

                    <filter-select
                        :filter-query="filterQuery"
                        :options="selectOptions.type"
                        :multiple="false"
                        options-label="text"
                        options-track-by="value"
                        filter-name="status"
                        :label="$t('filters.label.status_type')">
                    </filter-select>

                </div>
                <div class="col-4">
                  <div class="float-right mt-5">
                    <b-button @click="resetFilters()" variant="secondary" class="mr-2">{{$t('filters.btn.clear')}}</b-button>
                    <b-button @click="applyFilters()" variant="primary">{{$t('filters.btn.apply')}}</b-button>
                  </div>
                </div>
              </div>
            </div> <!-- #filters-->
            <div class="row mt-2">


              <div class="col-12">
                <grid-pagination :total-count="totalCount"
                                 :per-page="perPage"
                                 :current-page="currentPage"
                                 @load-items="paginationReload"></grid-pagination>

                <div class="table-responsive">
                  <b-table striped show-empty
                           :empty-text="$t('table.no_results')"
                           :busy="isBusy"
                           hover
                           head-variant="dark"
                           outlined
                           :sort-by.sync="orderColumn"
                           :sort-desc.sync="orderDirection"
                           :no-local-sorting="true"
                           :items="items"
                           :fields="fields">

                    <template #cell(loginDate)="data">
                      <div>{{ data.value | dateFormat('YYYY-MM-DD HH:mm:ss') }}</div>
                    </template>

                    <template #cell(status)="data">
                      <b-badge pill variant="success" v-if="data.value === 0">{{ $t('status.success') }}</b-badge>
                      <b-badge pill variant="warning" v-if="data.value === 1">{{ $t('status.fail') }}</b-badge>
                    </template>

                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>{{$t('state.loading')}}</strong>
                      </div>
                    </template>

                  </b-table>
                </div> <!-- #table-responsive-->

                <grid-pagination :total-count="totalCount"
                                 :per-page="perPage"
                                 :current-page="currentPage"
                                 @load-items="paginationReload"></grid-pagination>

              </div>
            </div>
          </div> <!-- #card-body-->
        </div> <!-- #card questions sygni-grid-->
      </div>
    </div>
    </template>
    <div class="spinner-wrapper" v-else>
      <b-spinner></b-spinner>
    </div>
  </div>

</template>

<script>
import GridMixin from "../../../components/grid/GridMixin";
import FilterSelect from "../../../components/grid/filters/FilterSelect";
import FilterDateRangePicker from "../../../components/grid/filters/FilterDateRangePicker";
import GridPagination from "../../../components/grid/grid-pagination/GridPagination";


export default {
  mixins: [GridMixin],
  components: {
    FilterSelect,
    FilterDateRangePicker,
    GridPagination
  },
  data() {
    return {
      gridGetUrl: null,
      wallets: null,
      walletCurrency: null,
      orderColumn: 'loginDate',
      fields: [
        {key: 'loginDate', label: this.$t('table.header.login_date'), sortable: true},
        {key: 'ip', label: this.$t('table.header.ip')},
        {key: 'systemVersion', label: this.$t('table.header.system_version')},
        {key: 'userAgent', label: this.$t('table.header.user_agent')},
        {key: 'status', label: this.$t('table.header.status'), sortable: true},
      ],
      items: [],
      selectOptions: {
        walletCurrency: [

        ],
        type: [
          {value: 0, text: this.$t('option.success')},
          {value: 1, text: this.$t('option.fail')},
        ],
        containOperator: [
          {value: 'eq', text: this.$t('operator.contains')},
          {value: 'neq', text: this.$t('operator.not_contains')},
        ],
        comparisonOperator: [
          {value: 'eq', text: this.$t('operator.equales')},
          {value: 'gte', text: this.$t('operator.greater_then')},
          {value: 'lte', text: this.$t('operator.lower_than')},
          {value: 'btw', text: this.$t('operator.between')},
        ]
      },
    };
  },
  mounted() {
    this.getHistory()
  },
  beforeDestroy() {
    this.$emit('changeActiveTab');
  },
  methods: {
    changeCurrency($e) {
      this.getWallets($e.value);
    },
    getHistory() {
      if(this.player && this.player.id) {
        this.gridGetUrl = `/api/client-security/player/${this.player.id}/login-history`;
        this.loadItems();
      }
    }
  },
  watch: {
    player: function () {
      this.getHistory();
    }
  },
  computed: {
    player: function () {
      return this.$store.getters["players/player"];
    },
    apiKey: function () {
      return this.$store.getters["root/apiKey"];
    },
  }
}
</script>
